var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcListCheckAccent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list_check"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,23C5.935,23,1,18.065,1,12S5.935,1,12,1c1.837,0,3.657,0.463,5.263,1.339c0.484,0.265,0.663,0.872,0.398,1.357 s-0.872,0.664-1.357,0.399C14.992,3.378,13.504,3,12,3c-4.962,0-9,4.038-9,9c0,4.963,4.038,9,9,9c4.963,0,9-4.037,9-9 c0-0.533-0.052-1.071-0.157-1.644c-0.101-0.543,0.259-1.065,0.802-1.165c0.552-0.099,1.064,0.26,1.165,0.802 C22.938,10.688,23,11.344,23,12C23,18.065,18.065,23,12,23z M11.707,15.707l9-9c0.391-0.391,0.391-1.023,0-1.414 s-1.023-0.391-1.414,0L11,13.586l-3.293-3.293c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414l4,4 C10.488,15.902,10.744,16,11,16S11.512,15.902,11.707,15.707z",
    fill: "#25d1da"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcListCheckAccent);
export default __webpack_public_path__ + "static/media/ic_list_check_accent.aca759d001caa4e8da7aa6af36b4c048.svg";
export { ForwardRef as ReactComponent };